import Service from "./config/ConfigRepositoryAuth";

export default {
  async getAll() {
    return await Service.get("users");
  },

  async findById(id) {
    return await Service.get(`users/${id}`);
  },

  async create(user) {
    return await Service.post("users", user);
  },

  async update(user) {
    return await Service.put(`users/${user._id}`, user);
  },

  async updatePassword(id, password) {
    return await Service.put(`users/${id}/password`, { password });
  },

  async delete(id) {
    return await Service.delete(`users/${id}`);
  },
};
